import React from 'react';
import { createReactRenderer } from 'helpers/react-renderer';
import { resetStore } from 'pages/store/actions/employeeShops';
import store from 'pages/store';
import {
  putEmployeeShops,
  showEmployeeWithoutAccessWarning,
  showPutEmployeeShopsSuccess,
  trackPutEmployeeShopsError,
} from './utils/employeeShops';
import EmployeeShopsModule, { getEmployeeShopState } from './modules/EmployeeShopsModule';

interface Props {
  isPrimaryUser: boolean;
}

const EmployeeShops: React.FC<Props> = ({ isPrimaryUser = false }) => (
  <EmployeeShopsModule isPrimaryUser={isPrimaryUser} />
);

const RenderedComponent = createReactRenderer({
  component: EmployeeShops,
  selector: '[data-react-root="EmployeeShops"]',
  store,
});

// TODO: inherit from ReactWindowHistory.History
(window.history as any).onChangeState(
  { name: 'admin.views.employee', tab: 'details', id: undefined },
  () => {
    store.dispatch(resetStore());
    RenderedComponent.mount();
  },
  async () => {
    // When navigating away with unsaved changes
    const {
      employeeID,
      employeeShops,
      hasUnsavedChanges,
      ignoreUnsavedChanges,
      isLeavingWithoutShops,
    } = getEmployeeShopState();

    // Prevents components from not mounting after `putEmployeeShops` is sent
    RenderedComponent.unmount();

    if (!ignoreUnsavedChanges) {
      if (
        hasUnsavedChanges &&
        window.confirm('This page contains unsaved changes. Save changes?') // eslint-disable-line no-alert
      ) {
        try {
          await putEmployeeShops({
            employeeID,
            employeeShops,
          });
          showPutEmployeeShopsSuccess();
        } catch (error) {
          trackPutEmployeeShopsError({ error, flashNotifier: true });
        }
      }

      // Something went wrong and employee was kept with access to zero locations
      if (isLeavingWithoutShops) {
        showEmployeeWithoutAccessWarning();
      }
    }
  }
);

export default EmployeeShops;
